import {routes as auth} from './domains/auth'
import {routes as user} from './domains/user'
import {routes as role} from './domains/role'
import {routes as registration} from './domains/registration'
import {routes as country} from './domains/country'
import {routes as state} from './domains/state'
import {routes as city} from './domains/city'
import {routes as institution} from './domains/institution'
import {routes as institutionUnit} from './domains/institution_unit'
import {routes as literacy} from './domains/literacy'
import {routes as modality} from './domains/modality'
import {routes as registrationStatus} from './domains/registration_status'
import {routes as event} from './domains/event'
import {routes as knowledgeArea} from './domains/knowledge_area'
import {routes as place} from './domains/place'
import {routes as field} from './domains/field'
import {routes as criteria} from './domains/criteria'
import {routes as paperStatus} from './domains/paper_status'
import {routes as evaluationType} from './domains/evaluation_type'
import {routes as paperType} from './domains/paper_type'
import {routes as layout} from './domains/layout'
import {routes as signature} from './domains/signature'

export default [
  ...auth,
  ...user,
  ...role,
  ...registration,
  ...country,
  ...state,
  ...city,
  ...institution,
  ...institutionUnit,
  ...literacy,
  ...modality,
  ...registrationStatus,
  ...event,
  ...knowledgeArea,
  ...place,
  ...field,
  ...criteria,
  ...paperStatus,
  ...evaluationType,
  ...paperType,
  ...layout,
  ...signature
]



// WEBPACK FOOTER //
// ./src/app/routes.js